import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { useFeatureFlag, FeatureFlag } from '@moda/portal-stanchions';

type ScoringRules = {
  [key: string]: {
    path: string;
    weights: string;
  };
};

const DEFAULT_RULES: ScoringRules = {
  default: {
    path: '.*',
    weights: ''
  }
};

const isTreatmentValid = (treatment: FeatureFlag): treatment is ScoringRules =>
  treatment != null &&
  typeof treatment === 'object' &&
  !Array.isArray(treatment) &&
  Object.values(treatment).every(
    value =>
      value != null &&
      typeof value === 'object' &&
      !Array.isArray(value) &&
      typeof value.path === 'string' &&
      typeof value.weights === 'string'
  );

export const usePLPScoring = () => {
  const { pathname } = useLocation();
  const rules = useFeatureFlag('plp-scoring', [
    { default: DEFAULT_RULES },
    { getFromTreatment: treatment => (isTreatmentValid(treatment) ? treatment : DEFAULT_RULES) }
  ]);
  const rule = useMemo(
    () => Object.values(rules).find(rule => new RegExp(rule.path, 'g').test(pathname)),
    [rules, pathname]
  );

  return rule?.weights;
};
